import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getRootLists({ commit }, params) {
    return api.certificate
      .getRootList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_ROOT_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getOrgLists({ commit }, params) {
    return api.certificate
      .getOrgList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_ORG_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  getNodeLists({ commit }, params) {
    return api.certificate
      .getNodeList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_NODE_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getCertUserLists({ commit }, params) {
    return api.certificate
      .getUserList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_USER_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
